<template>
    <b-autocomplete v-bind="$props"
                    v-model="lazyValue"
                    clearable
                    autocomplete="off"
                    v-on="$listeners"
                    data-lpignore="true"
                    :loading="loading"
                    :disabled="loading || disabled"
                    :items="items">
        <template v-slot:item='{item}'>
            <v-row align="center" class="text-body-2">
                <v-col cols="3">
                    {{ item.data.id }}
                </v-col>
                <v-col>
                    <Flag :code="item.data.country ? item.data.country.code : null" />
                    {{ item.data.country ? item.data.country.label : 'Geen land' }}
                </v-col>
                <v-col>
                    <v-icon left small>mdi-clock-plus-outline</v-icon>
                    {{ item.data.created_at | formattedDate }}
                </v-col>
            </v-row>
        </template>
    </b-autocomplete>
</template>

<script>
import AbstractPrefilledAutocomplete from "@/components/General/Form/Select/Abstract/AbstractPrefilledAutocomplete";
import Dossier from "@/models/Dossier/Dossier";
import Flag from "@/components/General/Icon/Flag";

export default {
    components: {Flag},
    extends: AbstractPrefilledAutocomplete,
    props: {
        customerId: {
            required: true,
            type: Number,
        }
    },
    computed: {
        items() {
            return this.entries.map(entry => {
                return {
                    value: entry.id,
                    text: entry.id,
                    data: entry,
                }
            })
        },
    },
    methods: {
        getAllEntries() {
            return Dossier.api()
                .limit(this.limit)
                .with(['tripCountry'])
                .orderBy('created_at', 'desc')
                .where('customer_id', this.customerId)
                .get().then((response) => {
                this.entries = response;
            });
        }
    }
}
</script>
